(() => {
  if (customElements.get('ballroom-product')) return;
  class BallroomProduct extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('[data-bb-form]');
      this.select = this.querySelector('[data-bb-size]');
      this.variants = JSON.parse(this.querySelector('[data-bb-variants]').textContent);
      this.dialog = this.querySelector('[data-bb-lightbox]');
      this.busy = false;
      this.classList.add('cf-bb-ready');
      this.select.hidden = true;
      this.querySelector('.cf-bb-size-buttons').hidden = false;
      this.addEventListener('click', event => this.click(event), { signal });
      this.addEventListener('change', event => { if (event.target === this.select) this.choose(this.select.value, true); }, { signal });
      this.form.addEventListener('submit', event => this.add(event), { signal });
      this.dialog.addEventListener('close', () => { this.zoomFocus?.focus(); this.updateSticky(); }, { signal });
      this.addEventListener('keydown', event => this.keyboard(event), { signal });
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateSticky(); }); };
      this.overlayObserver?.disconnect();
      this.overlayObserver = new MutationObserver(schedule);
      document.querySelectorAll('cart-drawer, cart-notification, #cart-notification, details.menu-drawer-container').forEach(node => this.overlayObserver.observe(node, { attributes: true, attributeFilter: ['class', 'open'] }));
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('popstate', () => this.choose(new URL(location.href).searchParams.get('variant') || this.variants[0].id, false), { signal });
      this.choose(this.select.value, false);
    }
    disconnectedCallback() { this.abort?.abort(); this.overlayObserver?.disconnect(); if (this.frame) cancelAnimationFrame(this.frame); this.frame = 0; }
    choose(id, updateUrl) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.variant = variant;
      this.select.value = String(id);
      this.querySelectorAll('[data-bb-variant]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bbVariant === String(id))));
      this.querySelectorAll('[data-bb-price]').forEach(e => e.textContent = variant.price);
      this.querySelector('[data-bb-sticky-size]').textContent = variant.title;
      const quantity = this.form.elements.quantity;
      quantity.min = variant.min || 1;
      quantity.step = variant.increment || 1;
      if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
      quantity.value = String(Math.max(Number(quantity.min), Math.min(Number(quantity.value) || Number(quantity.min), variant.max ?? Infinity)));
      const photo = this.querySelector(`[data-media-id="${variant.imageId}"]`);
      if (photo) this.photo(photo);
      this.setBusy(this.busy);
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url); this.querySelector('[data-bb-status]').replaceChildren(); }
    }
    photo(link) {
      const image = this.querySelector('[data-bb-main-image]');
      image.src = link.dataset.src; image.srcset = link.dataset.srcset; image.alt = link.dataset.alt;
      this.querySelector('[data-bb-zoom]').href = link.href;
      this.querySelectorAll('[data-bb-photo]').forEach(p => p === link ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current'));
    }
    click(event) {
      const button = event.target.closest('[data-bb-variant]');
      if (button) this.choose(button.dataset.bbVariant, true);
      const quantityButton = event.target.closest('[data-bb-quantity]');
      if (quantityButton) { const input = this.form.elements.quantity; input.value = String(Math.max(Number(input.min) || 1, Math.min(input.max ? Number(input.max) : Infinity, (Number(input.value) || Number(input.min) || 1) + Number(quantityButton.dataset.bbQuantity) * (Number(input.step) || 1)))); input.dispatchEvent(new Event('change', { bubbles: true })); }
      const photo = event.target.closest('[data-bb-photo]');
      if (photo && !event.ctrlKey && !event.metaKey && !event.shiftKey) { event.preventDefault(); this.photo(photo); }
      const zoom = event.target.closest('[data-bb-zoom]');
      if (zoom && this.dialog.showModal && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
        event.preventDefault(); this.zoomFocus = zoom;
        const image = this.querySelector('[data-bb-enlarged]'); image.removeAttribute('srcset'); image.src = zoom.href; image.alt = this.querySelector('[data-bb-main-image]').alt;
        this.dialog.showModal(); this.updateSticky();
      }
      if (event.target.closest('[data-bb-close]')) this.dialog.close();
      if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); }
    }
    keyboard(event) {
      const photo = event.target.closest('[data-bb-photo]');
      if (!photo || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const links = [...this.querySelectorAll('[data-bb-photo]')];
      let index = links.indexOf(photo);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length;
      event.preventDefault(); this.photo(links[index]); links[index].focus();
    }
    updateSticky() {
      const footer = document.querySelector('.footer');
      const overlay = this.dialog.open || !!document.querySelector('cart-drawer.active,cart-notification.active,#cart-notification.active,details[open].menu-drawer-container');
      this.querySelector('[data-bb-sticky]').hidden = this.form.querySelector('[data-bb-add]').getBoundingClientRect().bottom > 0 || !!(footer && footer.getBoundingClientRect().top < innerHeight) || overlay || this.busy;
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-bb-add]').forEach(b => { b.disabled = busy || !this.variant.available; b.setAttribute('aria-busy', String(busy)); b.textContent = this.variant.available ? this.dataset[busy ? 'adding' : 'add'] : this.dataset.soldOut; });
      this.updateSticky();
    }
    feedback(text, error) {
      const node = this.querySelector('[data-bb-status]'); node.replaceChildren(document.createTextNode(text)); node.dataset.error = String(!!error);
      if (error) node.scrollIntoView({ block: 'center', behavior: 'auto' });
      if (!error) { const link = document.createElement('a'); link.href = window.routes?.cart_url || '/cart'; link.textContent = this.dataset.viewBag; node.append(link); }
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.variant.available || !this.form.reportValidity()) return;
      this.setBusy(true); this.querySelector('[data-bb-status]').replaceChildren();
      let started = false;
      try {
        const data = new FormData(this.form);
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        data.set('sections', cart?.getSectionsToRender ? cart.getSectionsToRender().map(s => s.id).join(',') : 'cart-icon-bubble');
        data.set('sections_url', location.pathname + location.search);
        cart?.setActiveElement?.(document.activeElement);
        started = true;
        const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) { this.feedback(result.description || this.dataset.error, true); return; }
        this.feedback(this.dataset.added, false);
        if (cart?.renderContents && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); }
        else if (result.sections?.['cart-icon-bubble']) { const html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html'); const target = document.querySelector('#cart-icon-bubble'); if (target) target.innerHTML = (html.querySelector('.shopify-section') || html.body).innerHTML; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'ballroom',productVariantId:result.variant_id,cartData:result});
      } catch { this.feedback(this.dataset[started ? 'uncertain' : 'error'], true); }
      finally { if (this.isConnected) this.setBusy(false); }
    }
  }
  customElements.define('ballroom-product', BallroomProduct);
})();
